import React, { useState } from 'react';
import {Input, Textarea, Checkbox, Switch, Select, Toggle, Search} from 'components/common';
import HtmlEditor from 'components/html-editor'
import EmailManager from './email-manager';


if (!hp.store.queries) {
	hp.store.queries = hp.store.queries || {}
}

const TimeEditor = function(props) {
	const {model, name, id} = props;
	const [value, setValue] = useState(Number(model[name]) == model[name] ? (model[name] / 60) : 0)

	return (
		<input type='number' id={id || name} value={value} className='form-control input-sm hp-input-max-120' onChange={e => {
			setValue(e.currentTarget.value);
			model[name] = e.currentTarget.value * (props.conversion || 1);
		}} />
	)
}

class RegisterEditor extends React.Component {
	componentDidMount() {
		// carregar dados
		//http.get()
	}

	render() {
		const {model, name, id} = this.props;

		return (
			<div>
				{id}
			</div>
		)
	}
}

class CertificateEditor extends React.Component {
	onGenerate = () => {
		const {model, name, id} = this.props;
		const params = {
			name: id,
			cert_path: 'private/security/idp/cert'
		}
		http.post('/humanportalconfigs/genCert.json', params, (response, success) => {
			if (success) {
				model[name] = response.cert
				this.forceUpdate()
			}
		})
	}

	render() {
		const {model, name, id} = this.props;

		return (
			<div>
				<div className="btn-group btn-group-xs">
					<button className='btn btn-default' onClick={this.onGenerate}>
						<em className="la la-certificate"/>
						<span>Gerar certificado</span>
					</button>
				</div>
				<textarea name={name} id={id} className="form-control" rows="10" readOnly={true} value={model.value || ''} />
			</div>
		)
	}
}

class TableEditor extends React.Component {
	constructor(props) {
		super(props)
		const { cfg } = props;
		this.ref = cfg.config && cfg.config.sortable ? React.createRef() : null;
		this.sortable_created = false;
	}

	componentDidUpdate() {
		if (!this.ref) {
			return;
		}
		if (this.sortable_created) {
			$(this.ref.current).sortable("destroy");
		}
		$(this.ref.current).sortable({
			handle: '.drag',
			update: (index, elem) => {
				const new_idx = elem.item.index();
				const old_idx = elem.item[0].getAttribute('aria_index');

				if (old_idx !== undefined && old_idx != new_idx) {
					const { cfg } = this.props;
					const _value = cfg._value instanceof Array ? cfg._value : cfg._value[cfg.config.select.active]

					_value.splice(new_idx, 0, _value.splice(old_idx, 1)[0]);
					cfg.value = JSON.stringify(cfg._value);
this.forceUpdate()
				}
			}
		})
		this.sortable_created = true;
	}

	onChange = () => {
		const { cfg } = this.props;
		cfg.value = JSON.stringify(cfg._value);
		this.forceUpdate();
	}

	render() {
		const { cfg, configs, onGetEditor } = this.props;
		const { config } = cfg;
		let disabled = false;

		if (config == null) {
			return null;
		}
		if (config.url_loader && !config.loaded) {
			config.loaded = true
			http.post(config.url_loader, [], (response, success) => {
				if (success) {
					cfg._value = response
					cfg.value = JSON.stringify(response)
				}
				this.forceUpdate()
			});
			return
		}
		if (config.enabled) {
			const cfg_enabled = configs.find(el => el.key == config.enabled);
			disabled = cfg_enabled && cfg_enabled.value == 0;
			if (cfg_enabled) {
				cfg_enabled.onChange = () => this.forceUpdate();
			}
		}
		const select = config.select;
		let select_el = null;
		let cfg_values = cfg._value || (
			cfg._value = JSON.parse(cfg.value ? cfg.value : cfg.default_value) || ((select || config.target) ? {}  : [])
		);
		if (select) {
			select.active = select.active || (select.options.length > 0 ? select.options[0].id : null);
			const options = select.options.map(op =>
				<option key={op.id} value={op.id}>{op.label}</option>
			)
			select_el = config.select_el =
				<select value={select.active} title={select.title || null} onChange={e => {
					select.active = e.target.value;
					this.forceUpdate();
				}}>
					{options}
				</select>;
			if (select.label) {
				select_el = <div><label>{select.label}</label>{select_el}</div>
			}
			cfg_values = cfg._value[select.active] || (cfg._value[select.active] = [])
		}
		else if (config.target) {
			cfg_values = cfg._value[config.target] || (cfg._value[config.target] = []);
		}
		const header = config.schema.map((column, i) => (
			<th key={i} style={{ width: column.width || null}}>{column.header || column.name}</th>
		));
		const rows = Array.isArray(cfg_values)
			? cfg_values.map((row, i) => {
				const values = config.schema.map(c => {
					if (c.url_template) {
						c.url = c.url_template.replace('{value}', select && select.active ? select.active : 0)
					}
					const editor = c.editor
						? onGetEditor(c, row, this.onChange)
						: <Input model={row} name={c.name} id={c.name + i} disabled={disabled} required={c.required || null} onBlur={this.onChange} />
					return (
						<td key={c.name} className={c.class || null}>
							{editor}
						</td>
					)
				});
				values.push(
					<td key={-1} className="right">
						<button className="btn btn-light btn-xs btn-circular" style={{ fontSize: "15px" }} disabled={disabled} onClick={() => {
							cfg_values.splice(i, 1);
							cfg.value = JSON.stringify(cfg._value);
							this.forceUpdate();
						}}>
							<em className="la la-times" />
						</button>
					</td>
				);
				if (config.sortable) {
					values.unshift(<td key={-2}><em className="la la-grip-vertical drag" /></td>)
				}
				return (
					<tr key={i} className={config.sortable ? 'sortable' : null} aria_index={i}>
						{values}
					</tr>
				);
			})
			: [];
		header.push(<th key={-1} className="right">
			<button className="btn btn-xs btn-light btn-circular" disabled={disabled} style={{ fontSize: "15px"}} onClick={() => {
				const nrow = config.schema.reduce(
					(value, column) => {
						value[column.name] = null;
						return value;
					},
					{}
				);
				cfg_values.push(nrow);
				//cfg.value = JSON.stringify(cfg_values);
				this.forceUpdate();
			}}>
				<em className="la la-plus" />
			</button>
		</th>);

		if (config.sortable) {
			header.unshift(<th key={-2} />)
		}
		return (
			<div>
				{select_el}
				<table className="regular_table_grid alternate fixed">
					<thead><tr>{header}</tr></thead>
					<tbody ref={this.ref}>{rows}</tbody>
				</table>
			</div>
		);
	}
}

class FormEditor extends React.Component {
	constructor(props) {
		super(props)
		const { cfg } = props;
		cfg._value = cfg.value ? JSON.parse(cfg.value) : {}
		Object.keys(cfg.config).forEach(name => {
			const c = cfg.config[name]
			c.id = `${cfg.key}_${name}`
		})
	}

	onChange = () => {
		const { cfg } = this.props
		cfg.value = JSON.stringify(cfg._value)
		this.forceUpdate()
	}

	render() {
		const { cfg, onGetEditor } = this.props
		const { config } = cfg

		if (config == null) {
			return null;
		}
		const editors = Object.keys(config).map(name => {
			const c = config[name]
			const editor = c.editor
				? onGetEditor(c, cfg._value, name, this.onChange)
				: <Input model={cfg._value} name={name} id={c.id} required={c.required || null} onBlur={this.onChange} />

			return (
				<div key={c.id} className="row form-group">
					<div className="col-xs-3">
						<label htmlFor={c.id}>{c.label || name}{c.label != name && hp.settings.env == 0 ? ` (${name})` : null}</label>
					</div>
					<div className="col-xs-9">
						{editor}
					</div>
				</div>
			)
		})

		return (
			<div className='widget-box no-margin pt-1'>
				{editors}
			</div>
		)
	}
}

class ConfigCat extends React.Component {
	constructor(props) {
		super(props);
		this.onExpand = this.onExpand.bind(this);
		this.onSave = this.onSave.bind(this);
	}

	editorEmail(cfg, configs, row = null, name = 'value', onChange = null) {
		return (<Input type='email' model={row || cfg} name={name} id={cfg.id || cfg.key} onChange={onChange} />);
	}

	editorCheckbox(cfg, configs, row = null, name = 'value', onChange = null) {
		return (<Checkbox model={row || cfg} name={name} id={cfg.id || cfg.key} className="pull-left" onChange={onChange} />);
	}

	editorSwitch(cfg, configs, row = null, name = 'value', onChange = null) {
		return (<Switch model={row || cfg} name={name} id={cfg.id || cfg.key} className="pull-left" onChange={onChange} />);
	}

	editorToggle(cfg, configs, row = null, name = 'value', onChange = null) {
		return (<Toggle model={row || cfg} name={name} id={cfg.id || cfg.key} className="pull-left" onChange={onChange} />);
	}

	editorNumber(cfg, configs, row = null, name = 'value', onChange = null) {
		return (<Input type='number' model={row || cfg} name={name} id={cfg.id || cfg.key} classNameEl='form-control input-sm hp-input-max-120' onChange={onChange} />);
	}

	editorUrl(cfg, configs, row = null, name = 'value', onChange = null) {
		return (<Input type='url' model={row || cfg} name={name} id={cfg.id || cfg.key} onChange={onChange} />);
	}

	editorDate(cfg, configs, row = null, name = 'value', onChange = null) {
		//return (<DatePicker model={row || cfg} name={name} id={cfg.id || cfg.key} />);
		return (<Input type="date" model={row || cfg} name={name} id={cfg.id || cfg.key} onChange={onChange} />);
	}

	editorMinute(cfg, configs, row = null, name = 'value', onChange = null) {
		return <TimeEditor model={row || cfg} name={name} id={cfg.id || cfg.key} conversion={60} onChange={onChange} />
	}

	editorHtml(cfg, configs, row = null, name = 'value', onChange = null) {
		return (
			<HtmlEditor model={row || cfg} name={name} id={cfg.id || cfg.key}
				config={{convert_urls : false}}
				tags={configs.tags || cfg.tags || null}
				onChange={onChange}
				height={325}
			/>
		);
	}

	editorText(cfg, configs, row = null, name = 'value', onChange = null) {
		return (<Textarea model={row || cfg} name={name} id={cfg.id || cfg.key} classNameEl='form-control' rows={5} onBlur={onChange} />);
	}

	editorCert(cfg, configs, row = null, name = 'value', onChange = null) {
		return (<CertificateEditor model={row || cfg} name={name} id={cfg.id || cfg.key} onBlur={onChange} />);
	}

	editorSelect(cfg, configs, row = null, name = 'value', onChange = null) {
		if (cfg.value && cfg.url && cfg.defaultOptions === undefined) {
			cfg.defaultOptions = null;
			http.get(
				cfg.url, {
					data: {value: cfg.value},
					silent: true
				}, (response, success) => {
					if (success) {
						cfg.defaultOptions = response;
						this.forceUpdate();
					}
				}
			)
		}
		const url = cfg.url_template ? null : (cfg.url || null)

		if (cfg.url_template && cfg.url) {
			if (hp.store.queries.hasOwnProperty(cfg.url)) {
				cfg.query = cfg.url
			}
			else {
				cfg.query = cfg.url
				hp.store.queries[cfg.url] = []
				http.get(
					cfg.url, {
						silent: true
					}, (response, success) => {
						if (success) {
							hp.store.queries[cfg.url] = response;
							this.forceUpdate();
						}
					}
				)
			}
		}
		let options = cfg.query ? (hp.store.queries[cfg.query] || null) : (cfg.defaultOptions || null)

		if (options && !cfg.multiple && cfg.xor != 0) {
			if (row && row[name] && configs.editor != 'form') {
				const value = row[name]
				const el = options.find(el => el.value == value)
				return (
					<span>{el ? (el.label || el.text) : value}</span>
				)
			}
			if (configs.key && Array.isArray(configs._value)) {
				// buscar configuracao selecionada
				const active = {}
				const _xor_options = []

				for (let _value of configs.config.select && configs.config.select.active ? configs._value[configs.config.select.active] : configs._value) {
					active[_value[cfg.name]] = 1
				}
				// mostrar apenas as opções ainda disponíveis, ou seja, que não constam da lista de selecionados em active
				for (let opt of options) {
					if (!active.hasOwnProperty(opt.value)) {
						_xor_options.push(opt)
					}
				}
				options = _xor_options
			}
		}
		return (
			<Select model={row || cfg} name={name} id={cfg.id || cfg.key} isMulti={cfg.multiple || false}
				url={url}
				options={options}
				onChange={onChange}
			/>
		);
	}

	editorTable(cfg, configs) {
		return <TableEditor cfg={cfg} configs={configs} onGetEditor={(c, row, onChange) => {
			return this["editor" + c.editor.capitalize()](c, cfg, row, c.name, onChange)
		}} />;
	}

	editorForm(cfg, configs) {
		return <FormEditor cfg={cfg} configs={configs} onGetEditor={(c, row, name, onChange) => {
			return this["editor" + c.editor.capitalize()](c, cfg, row, name, onChange)
		}} />;
	}

	editorEmailManager(cfg, configs) {
		return <EmailManager cfg={cfg} />
	}

	editorRegister(cfg, configs, row = null, name = 'value', onChange = null) {
		return (<RegisterEditor model={row || cfg} name={name} id={cfg.key} />);
	}

	renderEditor(cfg, configs) {
		const method_ed = 'editor' + cfg.editor.capitalize();
		if (this[method_ed] instanceof Function) {
			return this[method_ed](cfg, configs);
		}
		return (<Input model={cfg} name='value' id={cfg.key} />);
	}

	onSave(e) {
		e.stopPropagation();
		const configs = this.props.cat.configs.map(cfg => ({key: cfg.key, value: cfg.value}));
		/*
		(cat ? [cat] : (this.state.cats || [])).map(cat => {
			configs.push.apply(configs, cat.configs.map(cfg => ({key: cfg.key, value: cfg.value})));
		});
		*/
		http.post('/humanportalconfigs/save.json', {configs: configs}, (response, success) => {
			if (success && response) {
				this.props.cat.configs.forEach(config => {
					if (response.hasOwnProperty(config.key)) {
						config.value = response[config.key]
					}
				})
				this.forceUpdate()
			}
		});
	}

	onExpand() {
		const {cat} = this.props;
		cat._expanded = cat._expanded ? 0 : 1;
		this.forceUpdate();
	}

	render() {
		const {cat} = this.props;
		const content = cat._expanded
			?	<div className="widget-body pcontent panel-scroll">
					{cat.configs.map((cfg, j) => {
						let obs = cfg.obs ? trans.getif(cfg.obs) : null;
						let name = cfg.name ? trans.getif(cfg.name) : null;
						return (
							<div key={j} className="row form-group">
								<div className="col-xs-12 col-sm-3 col-md-2 no-padding-right" title={cfg.key}>
									<label className='pointer' htmlFor={cfg.key}>
										{name}
									</label>
								</div>
								<div className="col-xs-12 col-sm-9 col-md-10">
									{this.renderEditor(cfg, cat.configs)}
									{obs ? <div><span className='tip'><em className='fa fa-info-circle'/><span dangerouslySetInnerHTML={{__html: obs}} /></span></div> : null}
								</div>
							</div>
						)
					})}
				</div>
			: 	null;

		return (
			<div className="widget-box config">
				<div className="widget-title pointer" onClick={this.onExpand}>
					<h4>
						<em className='la la-sliders-h' />
						<span>{cat.label}</span>
					</h4>
					<div className="pull-right">
						{cat._expanded
							?	<button className="btn btn-xs btn-primary" style={{margin: "-2px 5px 0 0"}} onClick={this.onSave}>
									<em className="la la-check" />
									<span>{__('buttons_save')}</span>
								</button>
							:	null}
						<span><em className={classNames('la', cat._expanded ? 'la-angle-down' : 'la-angle-right')} /></span>
					</div>
				</div>
				{content}
			</div>
		);
	}
}

export class Config extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			data: props.categories || [],
			cats: props.categories || [],
			category: props.categories ? props.category : '',
			search: null
		};
		if (props.categories && props.categories.length > 0 && props.categories.length < 5) {
			props.categories[0]._expanded = 1;
		}
		/*
		this.observer = function(cat) {
			return {
				set: (target, prop, value) => {
					target[prop] = value;
					if (prop == 'value' && !cat._is_dirty) {
						cat._is_dirty = true;
						this.forceUpdate();
					}
					return true;
				}
			}
		}
		*/
		this.load(props);
	}

	load(props) {
		if (typeof this.state.category === 'undefined' || this.state.category != props.category) {
			http.get('/humanportalconfigs/get.json', {
				category: this.state.category = props.category
			}, (response, success) => {
				if (success) {
					if (response.config.length <= 5) {
						response.config[0]._expanded = true;
					}
					/*
					response.config.forEach(cat => {
						const configs = [];
						cat.configs.forEach(cfg => {
							configs.push(new Proxy(cfg, this.observer(cat)));
						})
						cat.configs = configs;
					})
					*/
					Object.assign(hp.store.queries, response.queries || {})
					this.setState({
						data: response.config,
						cats: response.config
					});
				}
			});
		}
	}

	componentWillReceiveProps(props) {
		this.load(props);
	}

	doSearch = (text) => {
		const cats = [];

		text = text.normalize();
		this.state.data.forEach(cat => {
			const config = text.in(cat.label) ? cat.configs : cat.configs.filter(cfg => text.in(cfg.name) || text.in(cfg.key));
			if (config.length > 0) {
				cats.push({
					label: cat.label,
					configs: config
				});
			}
		});
		if (text != '' && cats.length == 1) {
			cats[0]._expanded = 1;
		}
		this.setState({cats: cats});
	}

	render() {
		const cats = (this.state.cats || []).map((cat, i) =>
			<ConfigCat cat={cat} key={i} />
		);
		const is_dialog = this.props.dialog === undefined || this.props.dialog;

		return (
			<div>
				<div className={classNames("pull-right", is_dialog ? "pcontent" : null)}>
					<Search className="input-sm search" doSearch={this.doSearch} />
				</div>
				<div className="clearfix" />
				<div>
					{cats}
				</div>
			</div>
		);
	}
}

export default function (category = null) {
	http.get('/humanportalconfigs/get.json', {
		category: category
	}, (response, success) => {
		if (success) {
			Object.assign(hp.store.queries, response.queries || {})
			mbox.modal(
				<Config
					categories={response.config}
					category={category}
				/>, {
				title: 'configurações da aplicação',
				className: "modal-lg",
				buttons: ['close', {
					name: 'save',
					//close: 'after',
					onClick: closeCallback => {
						const configs = [];
						response.config.map(cat => {
							configs.push.apply(configs, cat.configs.map(cfg => ({key: cfg.key, value: cfg.value})));
						});
						http.post('/humanportalconfigs/save.json', {configs: configs}, (response, success) => {
							closeCallback();
						});
					}
				}]
			});
		}
	});
}
